export default __webpack_public_path__ + "static/media/angle-left-solid.49b8a238.svg";